import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import ProgressModal from "../../components/modals/ProgressModal";

export function QaReportsViewModel(logout) {
  const defaultFilters = {
    class: { value: -1, label: "All classes" },
    category: { value: -1, label: "All categories" },
    product: { value: -1, label: "All products" },
    supplier: { value: -1, label: "All suppliers" },
    startDate: null,
    endDate: null,
  };
  const qaReportOptions = [
    { value: 1, label: "Receiving Report" },
    { value: 2, label: "Shipping Report" },
  ];
  const [filters, setFilters] = useState(defaultFilters);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [reportType, setReportType] = useState({
    value: -1,
    label: "Select report",
  });
  const [products, setProducts] = useState([]);

  const showProgressModal = (message) => {
    setEmptyModelOpen({
      open: true,
      childComponent: <ProgressModal message={message} />,
    });
  };

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const printSelectedReport = async function () {
    showProgressModal("Generating report...");
    const reportUrl = (() => {
      switch (reportType.value) {
        case 1:
          return "qaReports/receivingReport";
        case 2:
          return "qaReports/shippingReport";

        default:
          return "error_type";
      }
    })();

    let callResult = await makePostApiCall(reportUrl, {
      filter: {
        ...filters,
        endDate: reportType.value === 6 ? filters.startDate : filters.endDate,
      },
    });

    if (callResult.success) {
      window.open(callResult.data.location, "_blank");
      setEmptyModelOpen({ open: false, childComponent: null });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      setEmptyModelOpen({ open: false, childComponent: null });
      showErrorModal(callResult.data.message);
    }

    return callResult;
  };

  function resetFilters() {
    setFilters(defaultFilters);
  }
  return {
    emptyModal,
    loading,
    setEmptyModelOpen,
    filters,
    printSelectedReport,
    qaReportOptions,
    setFilters,
    reportType,
    setReportType,
    resetFilters,
    products,
  };
}
